module.exports = __webpack_public_path__ + "static/media/next_icn.10c28c72.svg";